import type { MissionCategoryId } from '@e-socna/data-layer';

import type { ReferencesContext_MissionCategory } from '../../../contexts/ReferencesContext';

export const buildChildrenMap = (
  categories: readonly ReferencesContext_MissionCategory[],
): Map<
  MissionCategoryId | null,
  readonly ReferencesContext_MissionCategory[]
> => {
  const map = new Map<
    MissionCategoryId | null,
    ReferencesContext_MissionCategory[]
  >();

  for (const category of categories) {
    const key = (category.parentId ?? null) as MissionCategoryId | null;
    const existing = map.get(key);

    if (existing) {
      existing.push(category);
    } else {
      map.set(key, [category]);
    }
  }

  return map;
};

export const buildPathToNode = (
  categories: readonly ReferencesContext_MissionCategory[],
  nodeId: MissionCategoryId,
): readonly MissionCategoryId[] => {
  const categoryMap = new Map(categories.map((c) => [c._id, c]));
  const path: MissionCategoryId[] = [];
  let current = categoryMap.get(nodeId);

  while (current) {
    path.unshift(current._id);
    current = current.parentId
      ? categoryMap.get(current.parentId as MissionCategoryId)
      : undefined;
  }

  return path;
};
